export enum DoughnutChartTypes {
  OeeKpiCard,
  OeeKpiLargeCard,
}
